import moment from "jalali-moment";

// jDateField values from the personnel list are already Jalali calendar dates.
export const formatJalaliDateShort = (value) => {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return "-";
  try {
    const date = moment(value, "jYYYY-jMM-jDD", true);
    return date.isValid() ? date.locale("fa").format("jDD jMMM jYYYY") : "-";
  } catch {
    return "-";
  }
};
